export function updatePaymentChannelOrderV4(send) {
  return (payeeId, body, ...args) =>
    send(
      {
        path: '/v4/payees/{payeeId}/paymentChannels/order',
        pathParameters: { payeeId },
        type: 'put',
        query: undefined,
        body: body,
        headers: undefined,
        auth: 'oauth2',
        contentType: 'application/json',
      },
      ...args
    );
}
